import InviteCodeReminder from './InviteCodeReminder'

export default InviteCodeReminder
